import React, { Component } from 'react';
import { Alert } from '@paypalcorp/pp-react';
import PropTypes from 'prop-types';

// eslint-disable-next-line react/prefer-stateless-function
class AlertContainer extends Component {
  render() {
    const { theme, key, type, children, dismissable } = this.props;

    let alert = (
      <Alert
        key={key}
        type={type}
        theme={theme}
        closeButton={{
          className: 'alert-message',
          onClick: () => {
            this.props.onDismiss(this);
          },
        }}
      >
        {children}
      </Alert>
    );

    if (!dismissable) {
      alert = (
        <Alert key={key} type={type} theme={theme}>
          {children}
        </Alert>
      );
    }

    // Updating alert class name for each alert
    const alertClassName = `Alert Alert--${type} alert-component`;
    return <div className={alertClassName}>{alert}</div>;
  }
}

AlertContainer.propTypes = {
  dismissable: PropTypes.bool,
  key: PropTypes.string.isRequired,
  type: PropTypes.string.isRequired,
  theme: PropTypes.string.isRequired,
  children: PropTypes.node,
  onDismiss: PropTypes.func,
};

export default AlertContainer;
